import { createSlice, PayloadAction, SliceCaseReducers } from "@reduxjs/toolkit";
import { FileInputType, FileType } from "operations/schema/schema";

// Interface for state
export interface State {
  open: boolean;
  file: FileInputType | FileType | null;
}

// Interface for store reducers
interface Reducers extends SliceCaseReducers<State> {
  openFilePreview: (
    state: State,
    action: PayloadAction<{ file: FileInputType | FileType | null }>
  ) => State;
  closeFilePreview: (state: State) => State;
}

// Definition of actual (initial) state
export const initialState: State = {
  open: false,
  file: null,
};

// Definition of actual reducers
const reducers: Reducers = {
  openFilePreview: (state, { payload: { file } }) => {
    state.open = true;
    state.file = file;

    return state;
  },
  closeFilePreview: (state) => {
    state.open = false;
    state.file = null;
    return state;
  },
};

const storeBase = createSlice<State, Reducers>({
  name: "filePreview",
  initialState,
  reducers,
});

// To be imported and added in store/reducers
export default storeBase.reducer;

// Export all actions created in store, to be used in components
// I.e, if using setOpen defined in examples above, it would look like this
// export const { setOpen } = storeBase.actions;
export const { openFilePreview, closeFilePreview } = storeBase.actions;
